import { DEFAULT_LANGUAGE, LANGUAGES } from "../constants";
export const isSupportedLanguage = (code) => Boolean(LANGUAGES[code]);
export default function resolveLanguage(preferredLanguage) {
    if (preferredLanguage && isSupportedLanguage(preferredLanguage)) {
        return preferredLanguage;
    }
    return DEFAULT_LANGUAGE;
}
